var agi = agi || {};
agi.expressions = agi.expressions || {};

agi.expressions.DynamicHLSSmashupPlayer = function DynamicHLSSmashupPlayer(config) {
    this.config = config;
    this.isFullscreen = false;
    this.setupJWPlayer = false;
}

agi.expressions.DynamicHLSSmashupPlayer.prototype.init = function init() {
    this.originalWidth = '550px';
    this.originalHeight = '400px';
    this.cardContainer = document.createElement('div');
    this.cardContainer.style.height = this.originalHeight;
    this.cardContainer.style.width = this.originalWidth;
    this.cardContainer.style.margin = '0';
    this.cardContainer.style.marginLeft = 'auto';
    this.cardContainer.style.backgroundSize = "100% auto";
    this.cardContainer.id = "agi-expressions-card-container";

    this.config.loader.style.display = "block";
    this.pers = this.config.pers;
    this.selections = {};

    //send mode
    if (this.config.mode === 'init') {
        var backgroundURL = "url('" + this.config.assetPath + "img/menu_screen.jpg') no-repeat";
        var cardControls = this.addCardControls();
        var buttons = this.addButtons();
        this.loader = this.addLoader();
        this.loader.style.display = "none";

        this.cardContainer.style.background = backgroundURL;
        this.cardContainer.appendChild(cardControls);
        this.cardContainer.appendChild(buttons);
        this.cardContainer.appendChild(this.loader);
        this.config.container.appendChild(this.cardContainer);

        this.setupDefaultJWPlayer();
        this.resize();
    }
    //pickup mode
    else {
        if (this.pers["playlist_url"] !== undefined &&
            this.pers["vtt_url"] !== undefined) {

            this.setupDefaultJWPlayer();
            this.playVideo();
        }
        else {
            console.warn("Expression Product Error: Personalization not found.");
        }
    }

    if (this.config.sitegroup === "bma" && this.config.maySend) {
        var sendSiteButton = document.getElementById("display-buttons-bottom");
        if (sendSiteButton !== null) {
            sendSiteButton.style.display = "none";
        }
    }

    this.wireListeners();
    this.config.loader.style.display = "none";
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.wireListeners = function wireListeners() {
    window.addEventListener('resize', this.resize.bind(this));
}

agi.expressions.DynamicHLSSmashupPlayer.prototype.addCardControls = function addCardControls() {
    var cardControls = document.createElement('div');
    cardControls.id = "card-controls";
    cardControls.style.textAlign = "left";
    cardControls.style.marginLeft = this.config.controlsMarginLeft;
    cardControls.style.paddingTop = this.config.controlsPaddingTop;

    //TODO: make a CSS file that loads in with these
    var dropdowns = document.createElement('ol');
    dropdowns.id = "smashup-options";
    dropdowns.style.listStyle = "none";
    dropdowns.style.margin = this.config.dropdownsMargin;
    dropdowns.style.padding = this.config.dropdownsPadding;

    for (var i = 0; i < this.config.dropdowns.length; i++) {
        var dropdown = this.config.dropdowns[i];
        dropdowns.appendChild(
            this.createDropdown(dropdown.persName, dropdown.label, dropdown.key));
    }
    cardControls.appendChild(dropdowns);
    return cardControls;
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.createDropdown =
    function createDropdown(fieldName, defaultItemCopy, dataKey) {

        var container = document.createElement('li');
        container.style.margin = "0px 0px 15px 30px";

        var dropdown = document.createElement('select');
        dropdown.name = fieldName;
        dropdown.className = "select";
        dropdown.style.width = "50%";
        dropdown.style.margin = "0";
        dropdown.style.padding = "0";
        dropdown.style.fontSize = "16px";

        var defaultItem = document.createElement('option');
        defaultItem.innerHTML = defaultItemCopy;
        defaultItem.selected = "false";
        defaultItem.value = "default";
        dropdown.appendChild(defaultItem);

        var items = this.config.selectionData[dataKey];
        var lengthOfItems = items.length;

        for (var i = 0; i < lengthOfItems; i++) {
            var item = document.createElement('option');
            item.innerHTML = items[i][0];
            item.value = items[i][1];
            dropdown.appendChild(item);
        }

        dropdown.addEventListener('change', this.selectionChangedHandler.bind(this));
        container.appendChild(dropdown);

        return container;
    };

agi.expressions.DynamicHLSSmashupPlayer.prototype.addButtons = function addButtons() {
    var buttonRow = document.createElement('div');
    buttonRow.id = "buttonRow";
    buttonRow.style.position = "absolute";
    buttonRow.style.top = "350px";
    buttonRow.style.left = "20px";

    var previewButton = document.createElement('a');
    previewButton.style.background = "url('" + this.config.assetPath + "img/product-preview.png') no-repeat";

    previewButton.id = "gv-preview";
    previewButton.href = "#";
    previewButton.style.display = "inline-block";
    previewButton.style.height = this.config.previewButtonHeight;
    previewButton.style.width = this.config.previewButtonWidth;
    previewButton.style.backgroundSize = "100% auto";
    previewButton.addEventListener('click', this.previewButtonClickHandler.bind(this));
    buttonRow.appendChild(previewButton);
    this.previewButton = previewButton;

    var sendButton = document.createElement('a');
    sendButton.style.background = "url('" + this.config.assetPath + "img/product-send.png') no-repeat";
    sendButton.id = "gv-send";
    sendButton.href = "#";
    sendButton.style.display = "inline-block";
    sendButton.style.height = this.config.sendButtonHeight;
    sendButton.style.width = this.config.sendButtonWidth;
    sendButton.style.backgroundSize = "100% auto";
    sendButton.style.marginLeft = "5px";
    sendButton.style.opacity = ".5";

    //Added for BMA to hide the product send button if not signed in.
    if (this.config.sitegroup === "bma" && !this.config.maySend) {
        sendButton.style.display = "none";
    }

    buttonRow.appendChild(sendButton);
    this.sendButton = sendButton;
    this.sendButtonClickBind = this.getSendPlaylist.bind(this);

    return buttonRow;
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.addLoader =
    function addLoader() {
        var loaderDiv = document.createElement('div');
        loaderDiv.id = "playlist-loader";
        loaderDiv.style.width = this.originalWidth;
        loaderDiv.style.height = this.originalHeight;
        loaderDiv.style.background = "rgba(192,192,192,0.8)";
        loaderDiv.style.position = "absolute";
        loaderDiv.style.top = "0px";
        loaderDiv.style.left = "0px";
        loaderDiv.style.textAlign = "center";

        var loadingText = document.createElement('p');
        loadingText.innerHTML = "Loading...";
        loadingText.style.margin = "200px auto";
        loadingText.style.fontSize = "40px";
        loadingText.style.color = "white";
        loadingText.style.textShadow = "2px 2px black";
        loadingText.style.textAlign = "center";
        loaderDiv.appendChild(loadingText);
        return loaderDiv;
    };

agi.expressions.DynamicHLSSmashupPlayer.prototype.setupDefaultJWPlayer = function setupDefaultJWPlayer() {
    this.jwPlayerContainer = document.createElement('div');
    this.jwPlayerWrapper = document.createElement('div');

    this.jwPlayerContainer.style.display = "none";
    this.jwPlayerContainer.id = "jwPlayerContainer";
    this.jwPlayerWrapper.id = "jwPlayerWrapper";
    this.jwPlayerContainer.appendChild(this.jwPlayerWrapper);
    this.config.container.appendChild(this.jwPlayerContainer);

    jwplayer.key = "gtFewPsBNb3uhA6CgFqgrWaicDKqIzAo8X0I/CB7DPCwlLdn";
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.playVideo = function playVideo() {
    this.jwPlayerContainer.style.display = "block";
    this.createPlaylist();

    if (!this.setupJWPlayer) {
        jwplayer(this.jwPlayerWrapper).setup({
            playlist: this.playlist,
            androidhls: true,
            primary: 'html5',
            hlshtml: true,
            debug: true,
            width: parseInt(this.config.container.style.width),
            height: parseInt(this.config.container.style.height)
        }).on('complete', this.closeButtonClickHandler.bind(this)).on('ready', this.playerReady.bind(this));
    }
    else {
        jwplayer(this.jwPlayerWrapper).load(this.playlist);
    }
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.createPlaylist = function createPlaylist() {
    this.playlist = [
        {
            'image': this.config.assetPath + "img/poster.jpg",
            'file': location.protocol + this.pers["playlist_url"],
            'tracks': [
                {
                    'file': location.protocol + this.pers["vtt_url"],
                    'label': 'English',
                    'kind': 'captions',
                    'default': false
                }
            ]
        }
    ];
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.goFullscreen = function goFullscreen() {
    //Check to see if already in fullscreen
    if (this.isFullscreen)
        return;

    //Turn off scrollbars on the page
    document.body.style.overflow = "hidden";

    //Initialize wrapper
    this.config.container.style.background = "#000000";
    this.config.container.style.top = "0px";
    this.config.container.style.left = "0px";
    this.config.container.style.width = window.innerWidth + "px";
    this.config.container.style.height = window.innerHeight + "px";
    this.config.container.style.zIndex = "200";
    this.config.container.style.backgroundColor = "#FFFFFF";
    this.config.container.style.position = "fixed";

    this.addCloseButton();
    this.isFullscreen = true;
    this.resize();
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.addCloseButton = function addCloseButton() {
    //Add Close Button
    this.closeButton = document.createElement("img");
    this.config.container.appendChild(this.closeButton);

    this.closeButton.id = "expression-close-button";
    this.closeButton.src = this.config.assetPath + "img/close_skip.png";

    this.closeButton.setAttribute('style', 'width: initial !important');
    this.closeButton.style.position = "absolute";
    this.closeButton.style.cursor = "pointer";
    this.closeButton.style.display = "block";
    this.closeButton.addEventListener("click", this.closeButtonClickHandler.bind(this));
    this.closeButton.style.top = "0%";
    this.closeButton.style.right = "0%";

    //This is to bugfix awful importants in base css on AG
    var currentCssText = this.closeButton.style.cssText;
    this.closeButton.style.cssText = currentCssText +
        " width:137px !important; height:37px !important;";
}

agi.expressions.DynamicHLSSmashupPlayer.prototype.isReadyToPlay = function isReadyToPlay() {
    var numberOfPersonalizationsChosen = 0;
    for (var i = 0; i < this.config.dropdowns.length; i++) {
        var dropdown = this.config.dropdowns[i];
        var persKey = dropdown.persName;
        if (this.selections[persKey] !== undefined) {
            numberOfPersonalizationsChosen++;
        }
        else {
            break;
        }
    }
    return numberOfPersonalizationsChosen === this.config.dropdowns.length;
}

agi.expressions.DynamicHLSSmashupPlayer.prototype.selectionChangedHandler =
    function selectionChangedHandler(event) {
        var persField = event.target.name;
        if (event.target.value !== "default") {
            this.selections[persField] = event.target.value;
        } else {
            this.selections[persField] = undefined;
        }
        if (this.isReadyToPlay()) {
            this.sendButton.style.opacity = "1";
            this.sendButton.addEventListener("click", this.sendButtonClickBind);
        } else {
            this.sendButton.style.opacity = "0.5";
            this.sendButton.removeEventListener("click", this.sendButtonClickBind);
        }
    };

agi.expressions.DynamicHLSSmashupPlayer.prototype.previewButtonClickHandler =
    function previewButtonClickHandler(event) {
        event.preventDefault();
        if (this.isReadyToPlay()) {
            this.getPreviewPlaylist();
        }
    };

agi.expressions.DynamicHLSSmashupPlayer.prototype.closeButtonClickHandler =
    function closeButtonClickHandler(event) {
        if (this.isFullscreen !== true) {
            return;
        }
        if (this.previewButton) {
            this.previewButton.style.opacity = "1.0";
        }

        this.config.container.style.position = "relative";
        this.config.container.style.zIndex = "auto";

        //Turn Scrollbars On
        document.body.style.overflow = "visible";
        this.isFullscreen = false;

        if (this.closeButton !== undefined)
            this.config.container.removeChild(this.closeButton);
        if (this.config.mode === 'init') {
            try {
                var backgroundURL = "url('" + this.config.assetPath + "img/menu_screen.jpg') no-repeat";
                this.config.container.style.background = backgroundURL;
                this.config.container.style.backgroundSize = "100% auto";
                jwplayer(this.jwPlayerWrapper).remove();
            }
            catch (error) {
                //The player refused to remove itself so we will do it visually.
                this.jwPlayerContainer.style.display = "none"
            }
            this.cardContainer.style.display = "block";
        }
        else {
            var currentPosition = jwplayer(this.jwPlayerWrapper).getPosition();
            var duration = jwplayer(this.jwPlayerWrapper).getDuration();

            if (duration > 0 && Math.floor(duration) !== Math.floor(currentPosition)) {
                jwplayer(this.jwPlayerWrapper).stop();
            }
        }

        this.resize();
    };

agi.expressions.DynamicHLSSmashupPlayer.prototype.playerReady = function playerReady(event) {
    this.goFullscreen();
    var video = document.getElementsByTagName('video');
    if (video.length > 0) {
        video = video[0];
        video.addEventListener('webkitendfullscreen', this.closeButtonClickHandler);
    }
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.resize = function resize(event) {
    var container = this.config.container;
    if (this.isFullscreen) {
        this.fullscreenResize(container);
    }
    else {
        this.defaultResize(container);
    }
};

agi.expressions.DynamicHLSSmashupPlayer.prototype.fullscreenResize =
    function fullscreenResize(container) {
        container.style.width = window.innerWidth + "px";
        container.style.height = window.innerHeight + "px";
        if (container.parentNode !== null) {
            container.parentNode.style.width = "";
            container.parentNode.style.height = "";
        }
        jwplayer(this.jwPlayerWrapper).resize(window.innerWidth, window.innerHeight);
        window.scroll(0, 1);
    }

agi.expressions.DynamicHLSSmashupPlayer.prototype.getPreviewPlaylist =
    function getPreviewPlaylist() {
        var request = {
            url: location.protocol + this.config.generatePlaylistURL,
            method: "POST",
            responseType: "text",
            data: {
                //TODO: Replace This When Not Hardcoded
                "pn": this.config.videoProductNumber,
                "choices": this.selections
            }
        };
        var loader = new dpd.JSONLoader(request).load().then(
            this.playlistLoadedHandler.bind(this)
        );
        this.loader.style.display = "block";
    }

agi.expressions.DynamicHLSSmashupPlayer.prototype.getSendPlaylist =
    function getSendPlaylist(event) {
        if (this.config.maySend) {
            var request = {
                url: this.config.generatePlaylistURL,
                method: "POST",
                responseType: "text",
                data: {
                    //TODO: Replace This When Not Hardcoded
                    "pn": this.config.videoProductNumber,
                    "choices": this.selections
                }
            };
            var loader = new dpd.JSONLoader(request).load().then(
                function (loader) {
                    if (loader.data !== null) {
                        this.pers = loader.data;
                        this.config.sendButtonClickHandler(event);
                    }
                }.bind(this)
            );
            this.loader.style.display = "block";
        }
        else {
            alert("Please sign in to send this card.");
        }
    }

agi.expressions.DynamicHLSSmashupPlayer.prototype.playlistLoadedHandler =
    function playlistLoadedHandler(loader) {
        if (loader.data !== null) {
            this.pers = loader.data;
            this.loader.style.display = "none";
            this.cardContainer.style.display = "none";
            this.playVideo();
        }
    }

agi.expressions.DynamicHLSSmashupPlayer.prototype.defaultResize =
    function defaultResize(container) {
        var productWHRatio = 1;
        var innerHeightAdjustment = .95; //Add some padding for landscape
        var combinedPadding = 40;

        var containerSize = 550;

        if (container.parentNode !== null) {
            container.parentNode.style.width = "100%";
            container.parentNode.style.height = "100%";
        }

        if (window.innerHeight < containerSize) {
            containerSize = window.innerHeight * innerHeightAdjustment;
        }
        else if (container.parentNode !== null) {
            if (container.parentNode.offsetWidth < containerSize) {
                containerSize = container.parentNode.offsetWidth;
            }
        }

        if (containerSize > 550) {
            var scale = 1;
        } else {
            var scale = containerSize / 550;
        }

        this.setScale(container, container.parentNode, scale);
    }

agi.expressions.DynamicHLSSmashupPlayer.prototype.setScale =
    function setScale(container, parent, scale) {
        this.cardContainer.style.transformOrigin = "top left";
        this.cardContainer.style.webkitTransformOrigin = "top left";
        this.cardContainer.style.transform = "scale(" + scale + "," + scale + ")";
        this.cardContainer.style.webkitTransform = "scale(" + scale + "," + scale + ")";

        container.style.width = 550 * scale + 'px';
        container.style.height = 400 * scale + 'px';
        if (jwplayer(this.jwPlayerWrapper).getDuration() !== undefined) {
            jwplayer(this.jwPlayerWrapper).resize(550 * scale, 400 * scale);
        }
        if (parent !== null) {
            parent.style.width = container.style.width;
            parent.style.height = container.style.height;
            parent.style.margin = "0 auto";
        }
    }

